import {Box, TextField} from '@mui/material';
/* eslint-disable react/prop-types */

const NumberRangeFilter = ({
                               column,
                               maxLength = 20
                           }) => {
    const value = column.getFilterValue() ?? [null, null];
    const [min, max] = value;

    const update = (id, v) => {
        const next = [...value];
        next[id] = v === '' ? null : v;
        column.setFilterValue(next);
    };

    return (
        <Box display="flex" gap={1}>
            <TextField
                size="small"
                value={min ?? ''}
                inputProps={{maxLength, autoComplete: 'off'}}
                onChange={(e) => update(0, e.target.value)}
                label="Min"
            />
            <TextField
                size="small"
                value={max ?? ''}
                inputProps={{maxLength, autoComplete: 'off'}}
                onChange={(e) => update(1, e.target.value)}
                label="Max"
            />
        </Box>
    );
};
export default NumberRangeFilter;
